import React, { useCallback, MouseEvent, memo } from "react";
import MuiButton from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import clsx from "clsx";

import { useStyles } from "./button.styles";
import { IButtonProps } from "./interfaces";

export const Button = memo(
  ({
    children,
    isFullWidth = false,
    isDisabled = false,
    isLoading = false,
    type = "button",
    variant = "contained",
    className = undefined,
    onClick,
  }: IButtonProps) => {
    const classes = useStyles();
    const computedClassName = clsx(classes.root, className);

    const handleClick = useCallback(
      (evt: MouseEvent<HTMLButtonElement>) => {
        onClick && onClick(evt);
      },
      [onClick]
    );

    return (
      <MuiButton
        className={computedClassName}
        variant={variant}
        color="primary"
        fullWidth={isFullWidth}
        type={type}
        disabled={isDisabled}
        onClick={handleClick}
        disableElevation
      >
        {!isLoading && <div className={classes.content}>{children}</div>}
        {isLoading && <CircularProgress className={classes.loader} size={20} />}
      </MuiButton>
    );
  }
);
